import Grid from "@cloudscape-design/components/grid";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import React, { useEffect, useState } from "react";
import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  ColumnLayout,
  Container,
  ContentLayout,
  Header,
  HelpPanel,
  Link,
  SpaceBetween,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import { Navigation } from '../../../components/app/Navigation';
import { listVehicles } from "../../../graphql/queries";
import { ListVehiclesQueryVariables } from "../../../API";
import { fetchAuthSession } from "aws-amplify/auth";
import DashboardTyre from "../../w_tyre_services/dashboard_tyre";

Amplify.configure(config);



function TyreCostSavingsEfficiency() {
  //const [total_tyre, updateTotal_tyre] = useState(0);
  const [totalTyre, setTotalTyre] = useState(0);
  const [total_vehicle, updateTotal_vehicle] = useState(0);
  const [activeHref, setActiveHref] = React.useState("/vehicles/tyres/cost-savings-efficiency");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
//   const [vehicleList, setVehicleList] = useState<VehicleMasterTable[]>([]);
  const [UserGroup, setUserGroup] = useState("");
  const [isLoading, setIsLoading] = React.useState(true);




  async function checkUserGroup() {
    try {
      const { tokens } = await fetchAuthSession();
      console.log("User belongs to the following groups:", tokens?.accessToken.payload["cognito:groups"]);
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  }

  useEffect(() => {
    checkUserGroup();
  }, []);

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              {
                text: "Tyres",
                href: "/vehicles/tyres/",
              },
              {
                text: "Cost Savings Efficiency",
                href: "/vehicles/tyres/cost-savings-efficiency",
              },

            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error('Function not implemented.');
            }}              
          />
        }
       
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name="external" />
                </h3>
                <ul>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant="h1"
                info={
                  <Link
                    variant="info"
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }

              >
                {activeHref === "/vehicles/tyres/cost-savings-efficiency"
                  ? `Cost Savings Efficiency`
                  : ""}
              </Header>
            }
          >

            <div className="contentPlaceholder">
              <SpaceBetween size="l">
                <Grid gridDefinition={[
                  { colspan: { default: 12, xxs: 4 } },
                  { colspan: { default: 12, xxs: 8 } },
                  { colspan: { default: 12, xxs: 12 } },

                ]}
                >

                </Grid>
              </SpaceBetween>
            </div>

          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header="Split panel header">
            Split panel content
          </SplitPanel>
        }
      />
    </>

  );

}

export default TyreCostSavingsEfficiency;
